<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { leadInitials } from '../utils/crmPageUtils';

const props = defineProps({
  lead: { type: Object, default: () => ({}) },
  sizeClass: { type: String, default: 'size-9' },
});

const isPfa = computed(() => {
  const attrs =
    props.lead?.additional_attributes || props.lead?.additionalAttributes || {};
  return ['PFA', 'pfa', true, 'true'].includes(
    props.lead?.client_type || props.lead?.clientType || attrs.client_type
  );
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <span
    class="relative grid shrink-0 place-items-center rounded-full bg-lais-primary-50 font-redHatDisplay text-[12px] font-semibold text-lais-primary"
    :class="sizeClass"
  >
    <span v-if="isPfa" class="i-lucide-user-star size-4" aria-hidden="true" />
    <span v-else>{{ leadInitials(lead) }}</span>
    <span
      v-if="isPfa"
      class="absolute -right-0.5 -top-0.5 grid size-4 place-items-center rounded-full bg-lais-gold text-white"
      title="Cliente PFA"
      aria-label="Cliente PFA"
    >
      <span class="i-lucide-star size-2.5" aria-hidden="true" />
    </span>
  </span>
</template>
